import { useState } from 'react';
import { MY_QR } from '../../api/constants';
import { getDoctorSelectorList } from '../../store/idbHandler';
import DoctorFilterStripUi from '../../components/multiDocComponents/DoctorStrip';

export const MyQr = () => {
    const doctors = getDoctorSelectorList();
    const [selectedDoctorId, setSelectedDoctorId] = useState(() => doctors?.[0].id);
    const doctorsLength = doctors?.length || 0;

    return (
        <div className="flex flex-col space-y-8 w-full h-full">
            {doctorsLength > 1 ? (
                <div className="flex items-center space-x-8 overflow-x-auto px-16 py-12 border-b border-neutral-7">
                    {doctors?.map((doc) => (
                        <DoctorFilterStripUi
                            key={doc.id}
                            doctorName={`Dr. ${doc.personal.name.f || ''} ${
                                doc.personal.name.l || ''
                            }`.trim()}
                            doctorPic={doc.personal.pic}
                            onClick={() => {
                                setSelectedDoctorId(doc.id);
                            }}
                            showAptCount={false}
                            isSelected={selectedDoctorId === doc.id}
                        />
                    ))}
                </div>
            ) : null}
            <div className="flex-1 relative">
                <iframe className="w-full h-full" src={MY_QR(selectedDoctorId || '')} />
            </div>
        </div>
    );
};
